<script setup lang="ts">
import { DialogClose, type DialogCloseProps } from 'radix-vue';

const props = defineProps<DialogCloseProps & {
  testId?: string;
}>();
</script>

<template>
  <DialogClose v-bind="props" :data-testid="props.testId">
    <slot />
  </DialogClose>
</template>
